import { createPortal } from "react-dom";
import type { Order } from "../../lib/types.ts";

export interface BestellgruppeAnlegenDialogProps {
  offen: boolean;
  bestellungen: readonly Order[];
  onBestellgruppeAnlegen: (orderIds: string[]) => void;
  onAbbrechen: () => void;
}

export function BestellgruppeAnlegenDialog({
  offen,
  bestellungen,
  onBestellgruppeAnlegen,
  onAbbrechen,
}: BestellgruppeAnlegenDialogProps) {
  if (!offen) return null;

  return createPortal(
    <div
      className="board-editor-overlay open"
      role="presentation"
      onClick={(ereignis) => {
        if (ereignis.target === ereignis.currentTarget) onAbbrechen();
      }}
    >
      <section
        className="board-editor-dialog bestellgruppe-anlegen-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="bestellgruppeAnlegenTitel"
      >
        <div className="board-editor-head">
          <div className="board-editor-head-copy">
            <h2 id="bestellgruppeAnlegenTitel">Bestellgruppe anlegen</h2>
          </div>
        </div>
        <div className="board-editor-body">
          <p>Diese Bestellungen werden im Hub zusammengehörig geklammert:</p>
          <ul>
            {bestellungen.map((bestellung) => (
              <li key={bestellung.id as string}>{String(bestellung.orderNo || "Ohne Bestellnummer")}</li>
            ))}
          </ul>
        </div>
        <div className="board-editor-foot">
          <button className="btn-sec" type="button" onClick={onAbbrechen}>
            Abbrechen
          </button>
          <button
            className="btn-primary"
            type="button"
            onClick={() => onBestellgruppeAnlegen(bestellungen.map((bestellung) => bestellung.id as string))}
          >
            Bestellgruppe anlegen
          </button>
        </div>
      </section>
    </div>,
    document.body,
  );
}
